module.exports = "/_next/static/images/cdf06ad22dbdd773e05cdd8b05cb6261-sarlaft-xs.png.webp";